/*********************************
 * CART HELPERS (SHOPIFY CORRECT)
 *********************************/
const getCart = () => fetch("/cart.js").then(r => r.json());

const addToCart = (variantId, qty = 1) =>
  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id: variantId, quantity: qty })
  });

const removeAddonFromCart = async (variantId) => {
  const cart = await getCart();
  const item = cart.items.find(i => i.variant_id === Number(variantId));
  if (!item) return;

  return fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: item.key,     // 🔥 LINE ITEM KEY (IMPORTANT)
      quantity: 0
    })
  });
};

const refreshCartUI = () => {
  document.documentElement.dispatchEvent(
    new CustomEvent("cart:refresh", { bubbles: true })
  );
};

/*********************************
 * ADDON DATA (UNCHANGED)
 *********************************/
const addOnData = {
  "loss-protection": {
    title: "Loss Protection",
    price: "$30.00",
    description: "Safeguard your order from loss during shipping.",
    image: "https://cdn.shopify.com/s/files/1/0828/8944/1580/files/Loss_Protection_c5874bce-83f1-4dd8-98cc-e281727085c4.svg",
    pid: 52323023716652
  },
  "damage-protection": {
    title: "Damage Protection",
    price: "$100.00",
    description: "Protect your order from shipping damage.",
    image: "https://cdn.shopify.com/s/files/1/0828/8944/1580/files/Damage_Protection_5bb10528-4720-4359-8cb1-1efa7158d851.svg",
    pid: 52323004875052
  },
  "theft-protection": {
    title: "Theft Protection",
    price: "$20.00",
    description: "Protect your purchase from theft during shipping.",
    image: "https://cdn.shopify.com/s/files/1/0828/8944/1580/files/Theft_Protection_19a0faef-ae5c-4cab-aeff-bad5109e5818.svg",
    pid: 52323030860076
  }
};

/*********************************
 * UI ELEMENTS (SAFE)
 *********************************/
const panel = document.querySelector("#addon-info-panel");
const titleEl = panel?.querySelector(".addon-title");
const priceEl = panel?.querySelector(".addon-price");
const descEl = panel?.querySelector(".addon-description");
const imageEl = panel?.querySelector(".addon-image");
const addBtn = panel?.querySelector(".addon-add-to-cart");
const removeBtn = panel?.querySelector(".addon-remove-from-cart");

let activeAddon = null;

/*********************************
 * OPEN ADDON POPUP
 *********************************/
document.addEventListener("click", async (e) => {
  const icon = e.target.closest(".addon-icon");
  if (!icon || !panel) return;

  e.stopPropagation();

  const addon = addOnData[icon.dataset.addontype];
  if (!addon) return;

  activeAddon = addon;

  titleEl.textContent = addon.title;
  priceEl.textContent = addon.price;
  descEl.textContent = addon.description;
  imageEl.src = addon.image;

  addBtn.dataset.pid = addon.pid;
  removeBtn.dataset.pid = addon.pid;

  panel.classList.add("active");

  const cart = await getCart();
  const exists = cart.items.some(i => i.variant_id === addon.pid);

  addBtn.classList.toggle("hidden", exists);
  removeBtn.classList.toggle("hidden", !exists);
});

/*********************************
 * ADD BUTTON (OPTIMISTIC)
 *********************************/
addBtn?.addEventListener("click", async (e) => {
  e.preventDefault();
  e.stopPropagation();
  if (!activeAddon) return;

  // 🔥 UI FIRST
  addBtn.classList.add("hidden");
  removeBtn.classList.remove("hidden");

  document
    .querySelector(`.addon-icon[data-productid="${activeAddon.pid}"]`)
    ?.classList.add("added");

  try {
    await addToCart(activeAddon.pid, 1);
    refreshCartUI();
  } catch (err) {
    console.error(err);
    addBtn.classList.remove("hidden");
    removeBtn.classList.add("hidden");
  }
});

/*********************************
 * REMOVE BUTTON (SHOPIFY CORRECT)
 *********************************/
removeBtn?.addEventListener("click", async (e) => {
  e.preventDefault();
  e.stopPropagation();
  if (!activeAddon) return;

  // 🔥 UI FIRST
  removeBtn.classList.add("hidden");
  addBtn.classList.remove("hidden");

  document
    .querySelector(`.addon-icon[data-productid="${activeAddon.pid}"]`)
    ?.classList.remove("added");

  try {
    await removeAddonFromCart(activeAddon.pid); // ✅ LINE ITEM KEY USED
    refreshCartUI();
  } catch (err) {
    console.error(err);
    removeBtn.classList.remove("hidden");
    addBtn.classList.add("hidden");
  }
});

/*********************************
 * CLOSE POPUP SAFELY
 *********************************/
document.addEventListener("click", (e) => {
  if (
    panel?.classList.contains("active") &&
    !panel.contains(e.target) &&
    !e.target.closest(".addon-icon")
  ) {
    panel.classList.remove("active");
    activeAddon = null;
  }
});

/*********************************
 * SYNC ICONS ON CART REFRESH
 *********************************/
document.addEventListener("cart:refresh", async () => {
  const cart = await getCart();
  const ids = cart.items.map(i => i.variant_id);

  document.querySelectorAll(".addon-icon").forEach(icon => {
    const pid = Number(icon.dataset.productid);
    icon.classList.toggle("added", ids.includes(pid));
  });
});

document.addEventListener("DOMContentLoaded", () => {
  document.documentElement.dispatchEvent(
    new CustomEvent("cart:refresh", { bubbles: true })
  );
});
